import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import api from "@/lib/api";
import { formatDateTime } from "@/i18n";
import { Activity } from "lucide-react";

export default function ActivityLog() {
  const { t } = useTranslation();
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/activity?limit=200").then((r) => setItems(r.data));
  }, []);

  const labelAction = (a) =>
    ({ created: t("admin.activity.actionCreated"), updated: t("admin.activity.actionUpdated"), deleted: t("admin.activity.actionDeleted") }[a] || a);
  const labelEntity = (e) =>
    ({
      news: t("admin.dashboard.entityNews"),
      member: t("admin.dashboard.entityMember"),
      album: t("admin.dashboard.entityAlbum"),
      image: t("admin.dashboard.entityImage"),
      admin: t("admin.dashboard.entityAdmin"),
      message: t("admin.dashboard.entityMessage"),
    }[e] || e);

  return (
    <div data-testid="activity-log" className="space-y-8">
      <div>
        <div className="text-xs uppercase tracking-[0.3em] text-bordeaux-accent mb-2">{t("admin.activity.eyebrow")}</div>
        <h1 className="text-3xl font-bold tracking-tight text-slate-900">{t("admin.activity.title")}</h1>
        <p className="text-slate-600 mt-2">{t("admin.activity.subtitle")}</p>
      </div>

      <div className="bg-white border border-slate-200 rounded-sm overflow-hidden">
        {items.length === 0 ? (
          <div className="p-16 text-center text-slate-500">
            <Activity className="mx-auto mb-3" size={22} />
            <p className="text-sm">{t("admin.activity.empty")}</p>
          </div>
        ) : (
          <table className="w-full text-left text-sm">
            <thead>
              <tr className="bg-beige-light border-b border-slate-200">
                <th className="px-4 py-3 font-medium text-slate-900">{t("admin.activity.colTime")}</th>
                <th className="px-4 py-3 font-medium text-slate-900">{t("admin.activity.colUser")}</th>
                <th className="px-4 py-3 font-medium text-slate-900">{t("admin.activity.colAction")}</th>
                <th className="px-4 py-3 font-medium text-slate-900">{t("admin.activity.colEntity")}</th>
                <th className="px-4 py-3 font-medium text-slate-900">{t("admin.activity.colDetails")}</th>
              </tr>
            </thead>
            <tbody>
              {items.map((a) => (
                <tr key={a.id} data-testid={`activity-row-${a.id}`} className="border-b border-slate-100">
                  <td className="px-4 py-3 text-slate-600 tabular-nums whitespace-nowrap">{formatDateTime(a.timestamp)}</td>
                  <td className="px-4 py-3 text-slate-900 font-medium">{a.user_name || a.user_email}</td>
                  <td className="px-4 py-3 text-slate-600">{labelAction(a.action)}</td>
                  <td className="px-4 py-3 text-slate-600">{labelEntity(a.entity_type)}</td>
                  <td className="px-4 py-3 text-slate-500 max-w-md truncate">{a.summary}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
